import React from 'react'
import ScreenshotForm from './form'
import ScreenshotList from './list'

const ScreenshotReference = () => {
  return (
    <>
      <ScreenshotForm />
      <ScreenshotList />
    </>
  )
}

export default ScreenshotReference
